import React, { useState } from 'react'
import { Fire, Trophy, ChartLine, CalendarAlt, CakeCandles, Users, ChartPie, Gift, UserPlus, Plus } from '../../../components/icons/Icons'
import Image3 from "../../../assets/Images/img (3).png"

const css = `
  .rb-section {
    background: rgba(255,255,255,0.03);
    border: 0.5px solid rgba(255,255,255,0.08);
    border-radius: 12px;
    padding: 12px 14px 14px;
    margin-bottom: 10px;
  }
  .rb-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.45);
    margin: 0 0 8px;
  }
  .rb-line {
    height: 1.5px;
    border-radius: 2px;
    margin-bottom: 10px;
    opacity: 0.55;
  }
  .rb-tag {
    display: inline-flex;
    align-items: center;
    padding: 3px 9px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    margin: 2px;
    border: 0.5px solid;
    transition: filter 0.15s;
  }
  .rb-tag:hover { filter: brightness(1.25); }
  .rb-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.18s;
  }
  .rb-row:hover { background: rgba(255,255,255,0.05); }
  .rb-icon {
    width: 30px; height: 30px;
    border-radius: 8px;
    display: flex; align-items: center; justify-content: center;
    font-size: 13px;
    flex-shrink: 0;
  }
  .rb-event-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 10px;
    border-radius: 8px;
    border: 0.5px solid;
    margin-bottom: 6px;
    cursor: pointer;
    transition: filter 0.15s;
  }
  .rb-event-row:last-child { margin-bottom: 0; }
  .rb-event-row:hover { filter: brightness(1.08); }
  .rb-bar-wrap { margin-bottom: 8px; }
  .rb-bar-wrap:last-child { margin-bottom: 0; }
  .rb-bar-track {
    height: 3px;
    background: rgba(255,255,255,0.07);
    border-radius: 4px;
    overflow: hidden;
    margin-top: 3px;
  }
  .rb-bar-fill {
    height: 100%;
    border-radius: 4px;
    transition: width 0.8s ease;
  }
  .rb-connect-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    border-radius: 8px;
    margin-bottom: 4px;
    transition: background 0.18s;
    cursor: pointer;
  }
  .rb-connect-row:last-child { margin-bottom: 0; }
  .rb-connect-row:hover { background: rgba(255,255,255,0.05); }
  .rb-plus {
    width: 26px; height: 26px;
    border-radius: 7px;
    background: rgba(134,96,248,0.15);
    border: 0.5px solid rgba(134,96,248,0.3);
    color: #a78bfa;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    transition: background 0.15s;
  }
  .rb-plus:hover { background: rgba(134,96,248,0.3); }
  .rb-online-dot {
    position: absolute; bottom: 0; right: 0;
    width: 8px; height: 8px; border-radius: 50%;
    background: #4ADE80;
    border: 1.5px solid #0f0f23;
  }
`

const RightBar = ({ ...props }) => {

  const [trandingTags] = useState([
    { id: 1, label: "Appreciation",   color: "#8660F8" },
    { id: 2, label: "BirthdayWishes", color: "#F472B6" },
    { id: 3, label: "FestiveVibes",   color: "#4ADE80" },
    { id: 4, label: "TeamWork",       color: "#60A5FA" },
    { id: 5, label: "Achievement",    color: "#FACC15" },
    { id: 6, label: "Innovation",     color: "#818CF8" },
  ])

  const [mostEngaged] = useState([
    { id: 1, image: Image3,         isImage: true,  label: "Mike's Birthday",       tag: "156 interactions", color: "#F472B6" },
    { id: 2, icon: <Trophy />,      isImage: false, label: "Q4 Performance Awards", tag: "98 interactions",  color: "#FACC15" },
    { id: 3, icon: <CalendarAlt />, isImage: false, label: "Diwali Celebrations",   tag: "74 interactions",  color: "#FB923C" },
  ])

  const [upcomingEvents] = useState([
    { id: 1, icon: <CakeCandles />, label: "Sarah's Birthday",    days: "Tomorrow", color: "#F472B6" },
    { id: 2, icon: <Users />,       label: "Team Building",        days: "Dec 15",   color: "#60A5FA" },
    { id: 3, icon: <Gift />,        label: "Diwali Celebrations",  days: "Dec 20",   color: "#FB923C" },
  ])

  const [activity] = useState([
    { id: 1, label: "Posts Liked",         count: 12, max: 30, color: "#8660F8" },
    { id: 2, label: "Comments Made",       count: 30, max: 30, color: "#60A5FA" },
    { id: 3, label: "Posts Shared",        count: 5,  max: 30, color: "#4ADE80" },
    { id: 4, label: "Appreciations Given", count: 5,  max: 30, color: "#FACC15" },
  ])

  const [connectWith] = useState([
    { id: 1, image: Image3, name: "Robert Kim", designation: "Design Team" },
    { id: 2, image: Image3, name: "Lisa Chen",  designation: "Marketing"   },
  ])

  return (
    <>
      <style>{css}</style>

      <div className="right-bar" style={{ padding: "4px 0", display: "flex", flexDirection: "column" }}>

        {/* ── Trending Tags ── */}
        <div className="rb-section">
          <div className="rb-title">
            <Fire class_name={"orange-text-one"} />
            Trending Tags
          </div>
          <div className="rb-line" style={{ background: "linear-gradient(90deg, #FB923C, transparent)" }} />
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            {trandingTags.map(item => (
              <span key={item.id} className="rb-tag" style={{
                color: item.color,
                background: `color-mix(in srgb, ${item.color}, transparent 84%)`,
                borderColor: `color-mix(in srgb, ${item.color}, transparent 58%)`,
              }}>
                #{item.label}
              </span>
            ))}
          </div>
        </div>

        {/* ── Most Engaged ── */}
        <div className="rb-section">
          <div className="rb-title">
            <ChartLine class_name={"text-green"} />
            Most Engaged
          </div>
          <div className="rb-line" style={{ background: "linear-gradient(90deg, #4ADE80, transparent)" }} />
          {mostEngaged.map((item, i) => (
            <div key={item.id} className="rb-row">
              <span style={{ fontSize: "10px", color: "rgba(255,255,255,0.2)", fontWeight: 700, width: 12, flexShrink: 0 }}>
                {i + 1}
              </span>
              {item.isImage
                ? <div style={{ width: 30, height: 30, borderRadius: "8px", overflow: "hidden", flexShrink: 0 }}>
                    <img src={item.image} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                  </div>
                : <div className="rb-icon" style={{ background: `color-mix(in srgb, ${item.color}, transparent 80%)`, color: item.color }}>
                    {item.icon}
                  </div>
              }
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: "#e5e7eb", fontSize: "12px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {item.label}
                </div>
                <div style={{ color: "#6b7280", fontSize: "10px" }}>{item.tag}</div>
              </div>
              <div style={{ width: 24, height: 3, borderRadius: 4, background: `color-mix(in srgb, ${item.color}, transparent 50%)`, flexShrink: 0 }} />
            </div>
          ))}
        </div>

        {/* ── Upcoming Events ── */}
        <div className="rb-section">
          <div className="rb-title">
            <CalendarAlt class_name={"text-info"} />
            Upcoming Events
          </div>
          <div className="rb-line" style={{ background: "linear-gradient(90deg, #60A5FA, transparent)" }} />
          {upcomingEvents.map(item => (
            <div key={item.id} className="rb-event-row" style={{
              background: `color-mix(in srgb, ${item.color}, transparent 92%)`,
              borderColor: `color-mix(in srgb, ${item.color}, transparent 65%)`,
            }}>
              <div className="rb-icon" style={{ background: `color-mix(in srgb, ${item.color}, transparent 76%)`, color: item.color }}>
                {item.icon}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ color: "#e5e7eb", fontSize: "12px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {item.label}
                </div>
                <div style={{ color: item.color, fontSize: "10px", opacity: 0.85 }}>{item.days}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Your Activity ── */}
        <div className="rb-section">
          <div className="rb-title">
            <ChartPie class_name={"text-purple"} />
            Your Activity
          </div>
          <div className="rb-line" style={{ background: "linear-gradient(90deg, #8660F8, transparent)" }} />
          {activity.map(item => (
            <div key={item.id} className="rb-bar-wrap">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ color: "#9ca3af", fontSize: "11px" }}>{item.label}</span>
                <span style={{ color: item.color, fontSize: "11px", fontWeight: 600 }}>{item.count}</span>
              </div>
              <div className="rb-bar-track">
                <div className="rb-bar-fill" style={{
                  width: `${Math.round((item.count / item.max) * 100)}%`,
                  background: item.color,
                }} />
              </div>
            </div>
          ))}
        </div>

        {/* ── Connect With ── */}
        <div className="rb-section">
          <div className="rb-title">
            <UserPlus class_name={"text-green"} />
            Connect With
          </div>
          <div className="rb-line" style={{ background: "linear-gradient(90deg, #4ADE80, transparent)" }} />
          {connectWith.map(item => (
            <div key={item.id} className="rb-connect-row">
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{ position: "relative", width: 34, height: 34, flexShrink: 0 }}>
                  <img src={item.image} alt={item.name} style={{ width: "100%", height: "100%", borderRadius: "50%", objectFit: "cover" }} />
                  <div className="rb-online-dot" />
                </div>
                <div>
                  <div style={{ color: "#e5e7eb", fontSize: "12px", fontWeight: 500 }}>{item.name}</div>
                  <div style={{ color: "#6b7280", fontSize: "10px" }}>{item.designation}</div>
                </div>
              </div>
              <button className="rb-plus">
                <Plus class_name={""} />
              </button>
            </div>
          ))}
        </div>

      </div>
    </>
  )
}

export default RightBar